  // src/utils/supabaseClient.ts
  import { createClient } from '@supabase/supabase-js';
  import { trackUserAuth } from '../utils/analytics'; // Assuming this path is correct

  export const supabase = createClient(
    process.env.REACT_APP_SUPABASE_URL!,
    process.env.REACT_APP_SUPABASE_ANON_KEY!,
    {
      auth: {
        autoRefreshToken: true,
        persistSession: true,
        detectSessionInUrl: true,
        flowType: 'pkce'
      },
      global: {
        headers: {
          'X-Client-Info': 'sun-tap-app'
        }
      }
    }
  );

  // Set up auth state change tracker
  supabase.auth.onAuthStateChange((event, session) => {
    if (event === 'SIGNED_IN') {
      trackUserAuth(true, session?.user?.app_metadata?.provider || 'direct');
    } else if (event === 'SIGNED_OUT') {
      trackUserAuth(false);
    }
  });

  // Helper function to check if user is authenticated
  export const isAuthenticated = async (): Promise<boolean> => {
    try {
      const { data } = await supabase.auth.getSession();
      return !!data.session;
    } catch (error) {
      console.error('Error checking authentication:', error);
      return false;
    }
  };